<div class="d-flex align-items-center">
  <button class="btn btn-sm btn-outline-secondary mr-3" data-toggle="modal" data-target="#miscLineCreator" title="{{ 'Buttons.AddCustomHourLine' | translate }}" (click)="type = 'hour';customLine.reset()"><i class="far fa-clock" style="font-size:1rem"></i></button>
  <button class="btn btn-sm btn-outline-secondary" data-toggle="modal" data-target="#miscLineCreator" title="{{ 'OfferDetails.AddVariousLine' | translate }}"(click)="type = 'item';customLine.reset()"><i class="fas fa-pencil-ruler" style="font-size:1rem"></i></button>

</div>

<div id="miscLineCreator" modal class="modal fade" data-target="miscLineCreator" tabindex="-1" role="dialog" data-toggle="modal" aria-labelledby="modal" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ type == 'hour' ? ( 'Buttons.AddCustomHourLine' | translate ) : ('Buttons.AddMiscellaneousProductLine' | translate) }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <i class="fa fa-window-close red" aria-hidden="true"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="row align-items-center mb-3" *ngIf="type == 'hour'">
          <div class="col-3">{{ 'Standard.PriceGroup' | translate}}</div>
          <div class="col-9">
            <select class="form-control" [(ngModel)]="customLine.priceGroupId" (change)="switchPriceGroupForCustomLine()">
              <option [ngValue]="null">{{ 'Standard.NoneChosen' | translate }}</option>
              <option *ngFor="let x of priceGroups" [value]="x.priceGroupId">{{x.name}}</option>
            </select>
          </div>
        </div>
        <div class="row align-items-center mb-3">
          <div class="col-3">{{'Standard.Description' | translate}}</div>
          <div class="col-9">
            <input class="form-control" type="text" [(ngModel)]="customLine.name" name="customLineDescription">
          </div>
        </div>
        <div class="row align-items-center mb-3">
          <div class="col-3">{{'Standard.CostPrice' | translate}}</div>
          <div class="col-9">
            <div class="input-group">
              <input class="form-control" type="text" [(ngModel)]="customLine.costPrice" name="costPrice" (ngModelChange)="calcPrice('cost')" currencyMask [options]="currencyMask" [disabled]="type == 'hour'" autocomplete="off">
              <div class="input-group-append">
                <span class="input-group-text" id="basic-addon2">Kr.</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row align-items-center mb-3" *ngIf="type != 'hour'">
          <div class="col-3">{{'Standard.Profit' | translate}}</div>
          <div class="col-9">
            <div class="input-group">
              <input class="form-control text-right" type="text" [(ngModel)]="customLine.profit" name="profit" (ngModelChange)="calcPrice('profit')" currencyMask [options]="currencyMask" autocomplete="off">
              <div class="input-group-append">
                <span class="input-group-text" id="basic-addon2">%</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row align-items-center mb-3">
          <div class="col-3">{{'Standard.SalesPrice' | translate}}</div>
          <div class="col-9">
            <div class="input-group">
              <input class="form-control" type="text" [(ngModel)]="customLine.salesPrice" name="salesPrice" (ngModelChange)="calcPrice('sales')" currencyMask [options]="currencyMask" [disabled]="type == 'hour'" autocomplete="off">
              <div class="input-group-append">
                <span class="input-group-text" id="basic-addon2">Kr.</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row align-items-center mb-3">
          <div class="col-3">{{'Standard.Quantity' | translate}}</div>
          <div class="col-9">
            <div class="input-group">
              <input class="form-control text-right" type="number" [(ngModel)]="customLine.amount" name="amount" autocomplete="off">
              <div class="input-group-append">
                <span class="input-group-text" id="basic-addon2">Stk.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-outline-danger mr-auto" (click)="customLine.reset()">{{ 'Buttons.Clear' | translate }}</button>
        <button class="btn btn-outline-secondary" data-dismiss="modal">{{ 'Buttons.Close' | translate }}</button>
        <button class="btn btn-outline-success" data-dismiss="modal" (click)="createCustomLine()" [disabled]="!customLine.name">{{ 'Buttons.CreateNew' | translate }}</button>
      </div>
    </div>
  </div>
</div>
